@let request = $request();
@let selectedRequestsIds = $selectedRequestsIds!();
@let isLoading = isLoading$ | async;
@let compactMode = mobileRequestsListCompactMode();
@let isDeliveryAddressDifferentFromActual =
  request.actualDeliveryAddress &&
  request.deliveryAddress &&
  request.actualDeliveryAddress !== request.deliveryAddress;

@let deliveryAddressConfirmed =
  request.actualDeliveryAddress &&
  request.actualDeliveryAddress === request.deliveryAddress;

@let ePTS = this.ePTS();
@let lPPhoto = this.lPPhoto();
@let appKDl = this.appKDl();
@let appKDkp = this.appKDkp();

<tui-swipe-actions>
  <x-icon-button
    tuiSwipeAction
    iconName="@tui.share"
    [clickFunction]="shareRequestLink.bind(this)"
    [backgroundPrimary]="true"
  />
  @if (canCreateTemporaryAccess()) {
    <x-icon-button
      tuiSwipeAction
      iconName="@tui.user"
      [iconSize]="16"
      [clickFunction]="openTemporaryAccessDialog.bind(this, $request().id)"
      [backgroundPrimary]="true"
    />
  }
  @if (this.$request().deliveryAddress) {
    <x-icon-button
      tuiSwipeAction
      iconName="@tui.navigation"
      [clickFunction]="openYaNav.bind(this)"
      [backgroundPrimary]="true"
    />
  }
  @if (ePTS) {
    <x-icon-button
      tuiSwipeAction
      iconName="x-icon::EPTS"
      [size]="44"
      [clickFunction]="createLink.bind(this, 'epts')"
      [backgroundPrimary]="true"
    />
  }
  @if (lPPhoto) {
    <x-icon-button
      tuiSwipeAction
      iconName="x-icon::photo-lp"
      [size]="44"
      [clickFunction]="createLink.bind(this, 'lPPhoto')"
      [backgroundPrimary]="true"
      [tuiHint]="'requests_list_item.lp_photo_hint' | translate"
      tuiHintAppearance="dark"
      [tuiHintShowDelay]="0"
      [tuiHintHideDelay]="0"
    />
  }
  @if (appKDl) {
    <x-icon-button
      tuiSwipeAction
      iconName="x-icon::DL"
      [size]="44"
      [clickFunction]="createLink.bind(this, 'appKDl')"
      [backgroundPrimary]="true"
      [tuiHint]="'requests_list_item.obrz_app_k_dl_hint' | translate"
      tuiHintAppearance="dark"
      [tuiHintShowDelay]="0"
      [tuiHintHideDelay]="0"
    />
  }
  @if (appKDkp) {
    <x-icon-button
      tuiSwipeAction
      iconName="x-icon::DKP"
      [size]="44"
      [clickFunction]="createLink.bind(this, 'appKDkp')"
      [backgroundPrimary]="true"
      [tuiHint]="'requests_list_item.obrz_app_k_dkp_hint' | translate"
      tuiHintAppearance="dark"
      [tuiHintShowDelay]="0"
      [tuiHintHideDelay]="0"
    />
  }

  @if (compactMode) {
    <div
      [tuiSkeleton]="!!isLoading"
      class="x-card x-card_size_s x-white mb-2 px-0 pt-0 pb-2"
      [routerLink]="['/requests', request.requestNumber]"
    >
      <section
        class="h-[32px] rounded-t-(--tui-radius-xl) px-2 py-1.5 flex items-center justify-between"
        [style.background]="hexToRgba(request.statusId?.color!, 0.5)"
      >
        <div class="me-2 p-1 h-full w-fit max-w-[40px]">
          <x-svg-icon
            [icon]="
              requestLeaseProductIconResolver(request.carType, request.carModel)
            "
            class="x-icon-svg car-type-icon-cp inline!"
          ></x-svg-icon>
        </div>
        <div class="x-font-paragraph-s font-extrabold truncate">
          {{ request.car }}
        </div>
        <input
          tuiCheckbox
          type="checkbox"
          tuiCheckbox
          size="m"
          class="mobile-list-checkbox ms-0.5"
          [ngModel]="selectedRequestsIds![request.id]"
          (ngModelChange)="onSelectRequest()"
          (click)="$event.stopPropagation()"
        />
      </section>
      <section
        class="mt-2 px-2.5 x-card__category flex items-center justify-between"
      >
        <div class="text-[15px]/[22px] font-extrabold basis-4/12">
          {{ request.releaseTime | releaseTimeParser }}
          @if (request.releaseDate) {
            <span class="-m-1"
              >, {{ request.releaseDate | date: 'dd.MM' }}
            </span>
          }
        </div>
        <div class="truncate basis-8/12">
          @if (request.deliveryName) {
            <p class="font-extrabold text-[8px]/[11px] truncate">
              {{ request.deliveryName }}
            </p>
          }
          @if (request.deliveryAddress) {
            <p
              class="typo-ui-s font-normal text-[8px]/[11px] truncate"
              [ngClass]="{
                'x-text-green': deliveryAddressConfirmed,
                'x-text-yellow': isDeliveryAddressDifferentFromActual,
              }"
            >
              {{ request.deliveryAddress }}
            </p>
          }
        </div>
      </section>
      <section class="mt-2 px-2 flex items-center justify-between">
        @if (request.vin) {
          <ng-container
            [ngTemplateOutlet]="inputCopy"
            [ngTemplateOutletContext]="{
              value: request.vin,
              small: true,
            }"
          />
        }
        @if (request.carPlantNumber) {
          <ng-container
            [ngTemplateOutlet]="inputCopy"
            [ngTemplateOutletContext]="{
              value: request.carPlantNumber,
              small: true,
              moveRight: !request.contract,
            }"
          />
        }
        @if (request.contract) {
          <ng-container
            [ngTemplateOutlet]="inputCopy"
            [ngTemplateOutletContext]="{
              value: request.contract,
              withIcon: true,
              small: true,
              moveRight: true,
            }"
          />
        }
      </section>
    </div>
  } @else {
    <div
      [tuiSkeleton]="!!isLoading"
      class="x-card x-card_size_m x-white mb-2 px-0 pt-0"
      [routerLink]="['/requests', request.requestNumber]"
    >
      <section
        class="h-[38px] rounded-t-(--tui-radius-xl) px-4 py-2 flex items-center justify-between"
        [style.background]="hexToRgba(request.statusId?.color!, 0.5)"
      >
        <input
          tuiCheckbox
          type="checkbox"
          tuiCheckbox
          size="m"
          class="me-3! mobile-list-checkbox"
          [ngModel]="selectedRequestsIds![request.id]"
          (ngModelChange)="onSelectRequest()"
          (click)="$event.stopPropagation()"
        />
        <div class="x-font-header-s font-extrabold basis-5/12">
          {{ request.releaseTime | releaseTimeParser }},
          {{ request.releaseDate | date: 'dd.MM' }}
        </div>
        <div
          class="x-font-paragraph font-extrabold basis-6/12 truncate text-right"
        >
          {{ 'request_statuses.' + request.statusId!.id | translate }}
        </div>
      </section>
      <section
        class="mt-1 px-4 x-card__category min-h-[60px] flex items-center justify-between"
      >
        <x-svg-icon
          [icon]="
            requestLeaseProductIconResolver(request.carType, request.carModel)
          "
          class="x-icon-svg car-type-icon me-2"
        ></x-svg-icon>
        <!-- flex-1: блок занимает всю ширину между иконкой ТС и кнопкой ПТС,
             иконки услуг идут от левого края, а не по центру -->
        <section class="min-w-0 flex-1">
          <div class="x-font-paragraph-l font-extrabold overflow-wrap-anywhere">
            {{ request.car }}
          </div>
          <div class="flex items-center">
            @for (
              requestProduct of request.products;
              track requestProduct.id;
              let idx = $index;
              let count = $count
            ) {
              @if (idx < 4) {
                <x-request-product-icon
                  [requestProduct]="requestProduct"
                  [requestDevices]="request.devices"
                  [withCounter]="true"
                  [iconSize]="RequestProductIconSize.Sm"
                ></x-request-product-icon>
              } @else if (idx === 4) {
                <div
                  class="flex items-center justify-center rounded-full border-[#808291] border-2 color-[#808291] w-[23px] h-[23px] text-[9px]/[9px] font-extrabold tracking-[0.1px]"
                >
                  + {{ count - idx }}
                </div>
              }
            }
          </div>
        </section>
        <x-icon-button
          iconName="x-icon::EPTS"
          [size]="44"
          [clickFunction]="createLink.bind(this, 'epts')"
          [disabled]="!ePTS"
          [tuiHint]="
            !ePTS ? ('requests_list_item.epts_not_found' | translate) : ''
          "
        />
      </section>

      <section class="flex justify-between items-center px-4">
        <div class="truncate basis-10/12">
          @if (request.deliveryName) {
            <p class="font-extrabold text-[15px]/[14px] truncate">
              {{ request.deliveryName }}
            </p>
          }
          @if (request.deliveryAddress) {
            <p class="typo-ui-s font-normal text-[10px]/[14px] truncate">
              {{ request.deliveryAddress }}
            </p>
          }
        </div>
        @if (request.deliveryAddress) {
          <div class="self-end">
            <x-icon-button
              iconName="@tui.navigation"
              [clickFunction]="openYaNav.bind(this)"
            />
          </div>
        }
      </section>
      @if (request.vin) {
        <section class="px-4">
          <ng-container
            [ngTemplateOutlet]="inputCopy"
            [ngTemplateOutletContext]="{
              value: request.vin,
            }"
          />
        </section>
      }
      @if (request.carPlantNumber) {
        <section class="px-4 mt-3">
          <ng-container
            [ngTemplateOutlet]="inputCopy"
            [ngTemplateOutletContext]="{
              value: request.carPlantNumber,
            }"
          />
        </section>
      }
      @if (request.contract) {
        <section class="px-4 mt-3 flex items-center justify-between">
          <ng-container
            [ngTemplateOutlet]="inputCopy"
            [ngTemplateOutletContext]="{
              value: request.contract,
              withIcon: true,
            }"
          />
          <x-icon-button
            iconName="@tui.share"
            [clickFunction]="shareRequestLink.bind(this)"
          />
        </section>
      }
    </div>
  }
</tui-swipe-actions>

<ng-template
  #inputCopy
  let-value="value"
  let-withIcon="withIcon"
  let-small="small"
  let-moveRight="moveRight"
  let-center="center"
>
  <div
    class="flex justify-between x-white-secondary rounded-xl items-center w-fit gap-2.5"
    [ngClass]="{
      'h-[30px]!': small,
      'h-[44px]!': !small,
      'ms-auto': moveRight,
      'mx-auto': center,
    }"
    (click)="copyToClipboard($event, value)"
  >
    <span
      class="font-extrabold flex items-center"
      [ngClass]="
        small ? 'mx-2 text-[10px]/[22px]' : 'mx-2.5 text-[15px]/[22px]'
      "
    >
      {{ value }}
      @if (withIcon) {
        <img
          class="ms-1.5"
          [ngSrc]="requestIconResolver(request.counterpartyOwnerId.id)"
          alt="cp icon"
          width="16"
          height="16"
        />
      }
    </span>
  </div>
</ng-template>
